"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SaferpayAltStatusResult = exports.SaferpayFieldsBancontactAppOptionsState = exports.SaferpayFieldValidationReason = exports.SaferpayFieldTypeEnum = void 0;
var SaferpayFieldTypeEnum;
(function (SaferpayFieldTypeEnum) {
    SaferpayFieldTypeEnum["CARDNUMBER"] = "cardnumber";
    SaferpayFieldTypeEnum["HOLDERNAME"] = "holdername";
    SaferpayFieldTypeEnum["EXPIRATION"] = "expiration";
    SaferpayFieldTypeEnum["CVC"] = "cvc";
})(SaferpayFieldTypeEnum || (exports.SaferpayFieldTypeEnum = SaferpayFieldTypeEnum = {}));
var SaferpayFieldValidationReason;
(function (SaferpayFieldValidationReason) {
    SaferpayFieldValidationReason["EMPTY"] = "empty";
    SaferpayFieldValidationReason["EXPIRED"] = "expired";
    SaferpayFieldValidationReason["INVALID"] = "invalid";
    SaferpayFieldValidationReason["UNSUPPORTED"] = "unsupported";
})(SaferpayFieldValidationReason || (exports.SaferpayFieldValidationReason = SaferpayFieldValidationReason = {}));
var SaferpayFieldsBancontactAppOptionsState;
(function (SaferpayFieldsBancontactAppOptionsState) {
    SaferpayFieldsBancontactAppOptionsState["LOADING"] = "loading";
    SaferpayFieldsBancontactAppOptionsState["ENABLED"] = "enabled";
    SaferpayFieldsBancontactAppOptionsState["DISABLED"] = "disabled";
})(SaferpayFieldsBancontactAppOptionsState || (exports.SaferpayFieldsBancontactAppOptionsState = SaferpayFieldsBancontactAppOptionsState = {}));
var SaferpayAltStatusResult;
(function (SaferpayAltStatusResult) {
    SaferpayAltStatusResult["CAPTURED"] = "CAPTURED";
    SaferpayAltStatusResult["FAILURE"] = "FAILURE";
    SaferpayAltStatusResult["PENDING"] = "PENDING";
})(SaferpayAltStatusResult || (exports.SaferpayAltStatusResult = SaferpayAltStatusResult = {}));
//# sourceMappingURL=SaferpayEnums.js.map